import { property_manager } from "../../Utils/export";

const WhoWeAre = () => (
  <section className="py-16 bg-white ">
    <div className="container mx-auto px-4">
      <div className="flex flex-col md:flex-row md:items-start md:gap-16 gap-10">
        {/* Left Text Content */}
        <div
          className="md:w-1/2"
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <h2 className="text-3xl font-bold mb-4">Who We Are</h2>
          <p className="text-gray-700 text-lg">
            121 Property is a comprehensive real estate platform designed to make your property journey effortless.
            Whether you’re a buyer, seller, tenant, agent, builder, or student — we’ve got something tailored just for you.
          </p>
        </div>

        {/* Right Image */}
        <div
          className="md:w-1/2"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <img
            src={property_manager}
            alt="Happy homeowners"
            className="rounded-lg shadow-lg w-full h-auto object-cover"
          />
        </div>
      </div>
    </div>
  </section>
);

export default WhoWeAre;
